/* TZ-RELATED-TRACKING (Round 5ah, Oct 17 2026) — GA4 select_item / view_item_list for the PDP "Related products" cards.
   List name/id: "related_products". Loaded by sections/tz-related-products.liquid. Passive: never prevents default or stops propagation;
   existing events (view_item, add_to_cart, ...) are untouched. Remove the <script> tag in that section to disable. */
(function () {
  if (window.__tzRelatedTracking) return;
  window.__tzRelatedTracking = true;
  var LIST = 'related_products';
  var SEL = 'product-recommendations[data-intent="related"]';
  function item(card, index) {
    return {
      item_id: String(card.getAttribute('data-product-card-id') || ''),
      item_name: card.getAttribute('data-product-title') || '',
      index: index,
      item_list_id: LIST,
      item_list_name: LIST
    };
  }
  function send(name, items) {
    if (!items || !items.length) return;
    var params = { item_list_id: LIST, item_list_name: LIST, items: items };
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: name, ecommerce: params });
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, { item_list_id: LIST, item_list_name: LIST, items: items, transport_type: 'beacon' });
      }
    } catch (e) {}
  }
  function cardsOf(root) {
    var out = [];
    var lis = root.querySelectorAll('li.grid__item');
    for (var i = 0; i < lis.length; i++) {
      var c = lis[i].querySelector('.product-card-wrapper');
      if (c) out.push(item(c, out.length + 1));
    }
    return out;
  }
  function onClick(e) {
    if (e.type === 'auxclick' && e.button !== 1) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var a = t.closest(SEL + ' li.grid__item a[href*="/products/"]');
    if (!a) return;
    var card = a.closest('.product-card-wrapper');
    var li = a.closest('li.grid__item');
    if (!card || !li || !li.parentNode) return;
    var idx = Array.prototype.indexOf.call(li.parentNode.children, li) + 1;
    send('select_item', [item(card, idx)]);
  }
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
  var fired = false;
  function arm(el) {
    if (fired || el.__tzArmed) return;
    var target = el.querySelector('ul.grid') || el;
    if (!('IntersectionObserver' in window)) return;
    el.__tzArmed = true;
    var io = new IntersectionObserver(function (entries) {
      if (fired) return;
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var its = cardsOf(el);
          if (its.length) { fired = true; io.disconnect(); send('view_item_list', its); }
          return;
        }
      }
    }, { threshold: 0.3 });
    io.observe(target);
  }
  function init() {
    var el = document.querySelector(SEL);
    if (!el) return;
    if (el.classList.contains('product-recommendations--loaded')) arm(el);
    new MutationObserver(function () {
      if (el.classList.contains('product-recommendations--loaded')) arm(el);
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
